import React from 'react';
import { Star } from 'lucide-react';
import Marquee from "react-fast-marquee";

const Testimonials = () => {
  const testimonials = [
    {
      name: "Harshitha",
      role: "Talent Acquisition Manager, Brilleo Technologies",
      quote: "Easy Hiring provided us with a complete team of Java developers in under two weeks. The quality of talent is exceptional.",
    },
    {
      name: "Tushar Singh",
      role: "Product Manager, Deccan AI",
      quote: "Their managed services model allowed us to focus on product strategy while they handled the entire development lifecycle.",
    },
    {
      name: "Renjith Kumar",
      role: "HR Manager, ZS Associates",
      quote: "We scaled our data science team from 2 to 10 in a month with Easy Hiring. Highly recommended for rapid scaling.",
    }
  ];

  return (
    <section id="testimonials" className="py-24 bg-gray-50 overflow-hidden">
      <div className="container mx-auto px-4 max-w-6xl mb-16 text-center">
        <span className="bg-purple-100 text-purple-700 text-sm font-bold px-4 py-2 rounded-full uppercase tracking-wider mb-6 inline-block">
          Success Stories
        </span>
        <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">What our partners say</h2>
        <p className="text-xl text-gray-600 max-w-2xl mx-auto">
          We build lasting relationships based on trust and delivery.
        </p>
      </div>

      <div className="relative">
        {/* Gradient Masks */}
        <div className="absolute top-0 left-0 w-32 h-full bg-gradient-to-r from-gray-50 to-transparent z-10"></div>
        <div className="absolute top-0 right-0 w-32 h-full bg-gradient-to-l from-gray-50 to-transparent z-10"></div>

        <Marquee 
          gradient={false} 
          speed={30} 
          pauseOnHover={true}
          className="py-4"
        >
          {testimonials.map((testimonial, index) => (
            <div 
              key={index} 
              className="w-[350px] md:w-[450px] bg-white p-8 rounded-2xl shadow-sm border border-gray-100 mx-4 flex flex-col justify-between h-full hover:shadow-md transition-shadow"
            >
              <div>
                <div className="flex text-amber-400 mb-4 gap-1">
                  {[1, 2, 3, 4, 5].map((star) => (
                    <Star key={star} className="w-4 h-4 fill-current" />
                  ))}
                </div>
                <p className="text-gray-700 leading-relaxed mb-6 italic text-lg">"{testimonial.quote}"</p>
              </div>
              <div className="flex items-center gap-4 mt-auto pt-6 border-t border-gray-50">
                <div className="w-10 h-10 rounded-full bg-gradient-to-br from-blue-100 to-indigo-100 flex items-center justify-center text-blue-700 font-bold text-lg">
                  {testimonial.name.charAt(0)}
                </div>
                <div>
                  <h4 className="font-bold text-gray-900 text-sm">{testimonial.name}</h4>
                  <p className="text-xs text-gray-500 font-medium uppercase tracking-wider">{testimonial.role}</p>
                </div>
              </div>
            </div>
          ))}
        </Marquee>
      </div>
    </section>
  );
};

export default Testimonials;
